import { Entry } from '../Entry'

export function Entry20220830() {
  return (
    <Entry title="30/08/2022 - v3.2.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12762/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
